import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function ManageProductRequest() {

    const navigate = useNavigate()
    const [requests, setRequests] = useState([])
    const backendUrl = process.env.REACT_APP_BACKEND_URI

    useEffect(() => {
        const token = localStorage.getItem("adminToken")
        if (!token) {
            navigate("/")
        } else {
            const fetchRequests = async () => {
                const res = await axios.get(`${backendUrl}/api/product-request`)
                setRequests(res.data)
            }
            fetchRequests()
        }
    }, [navigate, backendUrl])


    const deleteAllRequests = async () => {
        if (!window.confirm("Are you sure you want to delete ALL product requests?")) return;

        await axios.delete(`${backendUrl}/api/product-request`)
        setRequests([])
    }

    return (
        <div className="admin-page">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h2>Manage Product Requests</h2>

                <button
                    className="danger-btn"
                    onClick={deleteAllRequests}
                >
                    Delete All
                </button>
            </div>

            <table className="admin-table" style={{ textAlign: 'center' }}>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Product</th>
                        <th>Mobile</th>
                        <th>Quantity</th>
                        <th>Purpose</th>
                        <th>Requirement</th>
                    </tr>
                </thead>
                <tbody>
                    {requests.length === 0 ? (
                        <tr>
                            <td colSpan="6">No requests found</td>
                        </tr>
                    ) : (
                        requests.map(r => (
                            <tr key={r._id}>
                                <td>{new Date(r.createdAt).toLocaleDateString()}</td>
                                <td>{r.productName}</td>
                                <td>{r.countryCode} {r.mobile}</td>
                                <td>{r.quantity} {r.unit}</td>
                                <td>{r.purpose}</td>
                                <td>{r.requirement}</td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default ManageProductRequest;
